import React from "react";
import "./isp.css";
import ISPForm from "./ispForm";

export const ISPStepGuide = ({ lists, loggedIn, dataLoading, navigateToProposalFromISP, updateProposalsState, history, user }) => {
  if (dataLoading) {
    return (
      <div>
        <div
          style={{
            height: "calc(100vh - 50px)",
            position: "fixed",
            width: "100vw",
            backgroundColor: "#A2AAB6",
          }}
        />
        <div className="container">
          <div style={{ paddingTop: "35px" }}>
            <div className="card">
              <div className="card-body">
                <div style={{ textAlign: "center", padding: "50px" }}>
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                  <p style={{ marginTop: "20px" }}>
                    Loading ISP data, please wait...
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div
        style={{
          height: "calc(100vh - 50px)",
          position: "fixed",
          width: "100vw",
          backgroundColor: "#A2AAB6",
        }}
      />
      <div className="container">
        <div style={{ paddingTop: "35px" }}>
          <div className="card">
            <div className="card-body">
              <ISPForm lists={lists} loggedIn={loggedIn} navigateToProposalFromISP={navigateToProposalFromISP} updateProposalsState={updateProposalsState} history={history} user={user} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
